export const frequentQuestions = Array.from({ length: 6 }, (_, i) => ({
  title: `faq${i + 1}.title`,
  content: `faq${i + 1}.content`,
  extraContent: `faq${i + 1}.extraContent`,
}));
